import { ComponentType as w } from "../../registries/types/propTypes.js";
import { ThemeShades as A } from "../../../utils/themeColor.js";
const H = (r) => {
  var s;
  const n = Array.isArray(r == null ? void 0 : r.featured_articles_carousal) ? r == null ? void 0 : r.featured_articles_carousal[0] : r == null ? void 0 : r.featured_articles_carousal, p = n.display_heading ?? "", _ = ((s = n.items) == null ? void 0 : s.map((t) => {
    var l, i, c, a, u, m;
    const e = Array.isArray(t == null ? void 0 : t.featured_article) ? t.featured_article[0] : [], h = (i = (l = e == null ? void 0 : e.image) == null ? void 0 : l.images) == null ? void 0 : i.map((o) => ({
      url: o.image.url,
      altText: o.alt_text,
      viewport: o.viewport
    })), g = e.display_title ?? "", f = e.theme ?? "theme-black", y = (c = e.theme_color) == null ? void 0 : c.color, T = A.dark, b = e.description ?? "", k = e.headline ?? "", x = e.read_time ?? "", v = {
      text: ((a = e.link) == null ? void 0 : a.text) ?? "",
      url: ((u = e.link) == null ? void 0 : u.url) ?? "",
      target: (m = e.link) == null ? void 0 : m.target
    };
    return {
      images: h,
      brandTitle: g,
      cardTheme: f,
      themeColor: y,
      themeShade: T,
      brandDescription: b,
      brandHeadLine: k,
      brandReadTime: x,
      learnMore: v
    };
  })) || [];
  return {
    componentType: w.featured_articles_carousal,
    featuredArticleCarousalTitle: p,
    featuredArticleCarousalItems: _
  };
};
export {
  H as default
};
//# sourceMappingURL=featured-article-carousal-transformer.js.map
